module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Eject-2e0a0e5852f5a730890c170aa76b05b5.svg";